import { PriceUtils as BasePriceUtils } from '@wix/bookings-uou-mappers';
var PriceDtoFactory = /** @class */ (function () {
    function PriceDtoFactory() {
    }
    PriceDtoFactory.fromOfferingDto = function (offeringDto) {
        return {
            currency: offeringDto.payment.currency,
            price: offeringDto.payment.price,
            isFree: offeringDto.payment.isFree,
            isVariedPricing: offeringDto.payment.isVariedPricing,
            priceText: offeringDto.payment.priceText,
            minCharge: offeringDto.payment.minCharge,
            paymentType: offeringDto.payment.paymentType,
            displayTextForPlan: offeringDto.pricingPlanInfo
                ? offeringDto.pricingPlanInfo.displayText
                : '',
        };
    };
    return PriceDtoFactory;
}());
export { PriceDtoFactory };
var PriceUtils = /** @class */ (function () {
    function PriceUtils() {
    }
    PriceUtils.getFormattedCurrency = function (input) {
        return BasePriceUtils.getFormattedCurrency(input);
    };
    return PriceUtils;
}());
export { PriceUtils };
//# sourceMappingURL=price-dto-factory.js.map